/**
 * Our services living in k8s pods have a public and private URL.
 * This function transforms the private URL to the public URL.
 * @param podUrl - "podded" URL of give service
 * @returns
 */
export function getPublicServiceExternalUrlByK8sInternalUrl(podUrl: string): string {
  const parsed = new URL(podUrl);

  // If the hostname is localhost (local development env), we don't need to transform
  if (parsed.hostname === 'localhost') {
    return podUrl;
  }

  parsed.protocol = 'https:'; // we always use HTTPS on public URLs

  const parts = parsed.hostname.split('.');

  const idx = parts.findIndex((part) => part.endsWith('-public'));
  if (idx !== -1) {
    parts[idx] = 'www';
    parsed.hostname = parts.join('.');
  }

  let finalUrl = parsed.toString();

  // Ensure the final URL has a trailing slash if the original URL had one
  if (podUrl.endsWith('/') && !finalUrl.endsWith('/')) {
    finalUrl += '/';
  }

  return finalUrl;
}
